<script>
    // Modelled on the Progress page, which is the one place in the app that
    // already gets this right: say plainly that there is nothing here, say
    // what to do about it, give exactly one way to do it.
    //
    //   <EmptyState
    //     title="No progress photos yet."
    //     body="Take a face analysis now, then come back weekly to see what changes.">
    //     <Button on:click={goToFaceAnalysis}>Start first check-in</Button>
    //   </EmptyState>
    //
    // Never render an empty state that implies success. An empty analysis is
    // not "Your skin profile is ready."

    export let title;
    export let body = null;
</script>

<style>
    .empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: var(--space-4);
        padding: var(--space-16) var(--space-6);
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: var(--radius-0);
    }

    .icon { color: var(--text-muted); line-height: 1; }

    h2 {
        font-family: var(--font-display);
        font-size: var(--text-xl);
        font-weight: var(--weight-regular);
        line-height: var(--leading-snug);
        color: var(--cream);
        margin: 0;
    }

    p {
        max-width: 46ch;
        margin: 0;
        font-size: var(--text-sm);
        line-height: var(--leading-relaxed);
        color: var(--text-muted);
    }

    .action { margin-top: var(--space-2); }
</style>

<div class="empty">
    {#if $$slots.icon}
        <div class="icon"><slot name="icon" /></div>
    {/if}

    <h2>{title}</h2>

    {#if body}<p>{body}</p>{/if}

    {#if $$slots.default}
        <div class="action"><slot /></div>
    {/if}
</div>
